var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose, Type } from 'class-transformer';
import { IsDateString, IsOptional, IsString, IsUUID } from 'class-validator';
/**
 * Slim row for the topbar "next appointment" pill.
 *
 * `displayName` is server-formatted as "<FirstName> <LastInitial>." so the full
 * last name never crosses the wire — protects PII when the pill is visible on
 * every page.
 */
export class MyNextAppointmentRowDto {
    id;
    startsAt;
    endsAt;
    displayName;
    treatmentTypeCode;
}
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], MyNextAppointmentRowDto.prototype, "id", void 0);
__decorate([
    IsDateString(),
    Type(() => Date),
    Expose(),
    __metadata("design:type", Date)
], MyNextAppointmentRowDto.prototype, "startsAt", void 0);
__decorate([
    IsDateString(),
    Type(() => Date),
    Expose(),
    __metadata("design:type", Date)
], MyNextAppointmentRowDto.prototype, "endsAt", void 0);
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", String)
], MyNextAppointmentRowDto.prototype, "displayName", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], MyNextAppointmentRowDto.prototype, "treatmentTypeCode", void 0);
//# sourceMappingURL=my-next-appointment-row.dto.js.map